import { render, staticRenderFns } from "./channelAdd.vue?vue&type=template&id=4f716028&scoped=true"
import script from "./channelAdd.vue?vue&type=script&lang=js"
export * from "./channelAdd.vue?vue&type=script&lang=js"
import style0 from "./channelAdd.vue?vue&type=style&index=0&id=4f716028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f716028",
  null
  
)

export default component.exports